<div class="formContainer">
    <h2>Node Configuration Devices</h2>
    <form *ngIf="form" [formGroup]="form" (ngSubmit)="save()">
        <div>
            <mat-form-field appearance="fill">
                <mat-label>Refresh rate (minutes)</mat-label>
                <input matInput formControlName="frequencyMinutes" required/>
                <mat-error *ngIf="form.get('frequencyMinutes')?.hasError('required')">Refresh rate is required</mat-error>
                <mat-error *ngIf="form.get('frequencyMinutes')?.hasError('pattern')">Refresh rate must be a number</mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Timeout (seconds)</mat-label>
                <input matInput formControlName="timeoutSeconds" required/>
                <mat-error *ngIf="form.get('timeoutSeconds')?.hasError('required')">Timeout is required</mat-error>
                <mat-error *ngIf="form.get('timeoutSeconds')?.hasError('pattern')">Timeout must be a number</mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Number of records</mat-label>
                <input matInput formControlName="records" required/>
                <mat-error *ngIf="form.get('records')?.hasError('required')">Number of records is required</mat-error>
                <mat-error *ngIf="form.get('records')?.hasError('pattern')">Number of records must be a number</mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>CSV Separator</mat-label>
                <input matInput formControlName="separator" />
            </mat-form-field>
        </div>
        <h3>Devices</h3>
        <button type="button" class="button mt-2" (click)="addDevice()">
            {{ 'Add new device' }}
        </button>
        <div formArrayName="devices">
            <div *ngFor="let device of devices.controls; let i = index" [formGroupName]="i" class="form">
                <mat-form-field appearance="fill">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" required />
                    <mat-error *ngIf="device.get('name')?.hasError('required')">Name is required</mat-error>
                </mat-form-field>
            
                <mat-form-field appearance="fill">
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="address" required />
                    <mat-error *ngIf="device.get('address')?.hasError('required')">Address is required</mat-error>
                    <mat-error *ngIf="device.get('address')?.hasError('pattern')">The address must be a valid IP</mat-error>
                </mat-form-field>
            
                <mat-form-field appearance="fill">
                    <mat-label>Port</mat-label>
                    <input matInput formControlName="port" required />
                    <mat-error *ngIf="device.get('port')?.hasError('required')">Port is required</mat-error>
                    <mat-error *ngIf="device.get('port')?.hasError('pattern')">Port must be a number</mat-error>
                </mat-form-field>
            
                <mat-form-field appearance="fill">
                    <mat-label>Version</mat-label>
                    <mat-select formControlName="version" required>
                        <mat-option *ngFor="let version of versions" [value]="version">{{ version }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="device.get('version')?.hasError('required')">Version is required</mat-error>
                </mat-form-field>
            
                <mat-form-field appearance="fill">
                    <mat-label>Community</mat-label>
                    <input matInput formControlName="community" />
                </mat-form-field>
            
                <!-- Campos adicionales que se mostrarán si se selecciona "Other" -->
                <div *ngIf="device.get('version')?.value === 'V3'">
                    <mat-form-field appearance="fill">
                        <mat-label>Security Level</mat-label>
                        <mat-select formControlName="securityLevel">
                        <mat-option *ngFor="let level of securityLevels" [value]="level">{{ level }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="device.get('securityLevel')?.hasError('required')">Security Level is required</mat-error>
                    </mat-form-field>
                
                    <mat-form-field appearance="fill">
                        <mat-label>Authentication</mat-label>
                        <mat-select formControlName="authentication">
                        <mat-option *ngFor="let auth of authentications" [value]="auth">{{ auth }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                
                    <mat-form-field appearance="fill">
                        <mat-label>Authentication Phrase</mat-label>
                        <input matInput formControlName="authenticationPhrase" />
                    </mat-form-field>
                
                    <mat-form-field appearance="fill">
                        <mat-label>Privacy Phrase</mat-label>
                        <input matInput formControlName="privacyPhrase" />
                    </mat-form-field>
                
                    <mat-form-field appearance="fill">
                        <mat-label>User</mat-label>
                        <input matInput formControlName="user" />
                    </mat-form-field>
                
                    <mat-form-field appearance="fill">
                        <mat-label>Context</mat-label>
                        <input matInput formControlName="context" />
                    </mat-form-field>
                </div>
                
                <div class="form" formArrayName="objects">
                    <h3>Objects</h3>
                    <mat-list>
                        <mat-list-item *ngFor="let object of getObjects(device).controls; let j = index" [formGroupName]="j">
                            <span>{{ object.get('name')?.value }} - {{ object.get('oid')?.value }}</span>
                            <button type="button" mat-icon-button (click)="editObjectConfiguration(object)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button type="button" mat-icon-button (click)="deleteObject(device, j)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </mat-list-item>
                    </mat-list>
                
                
                    <button type="button" class="button mt-2" (click)="addObject(device)">
                        {{ 'Add SNMP Object' }}
                    </button>
                    <button type="button" class="button mt-2" *ngIf="configuration" [disabled]="mibDialogShown" (click)="loadMib(device)">Load
                        MIB</button>
                    
                </div>

                <button type="button" class="button mt-2" *ngIf="configuration" [disabled]="mibDialogShown" (click)="deleteDevice(i)">
                    Delete device
                </button>
            </div>
        </div>
    
        <button mat-raised-button color="primary" type="submit">Submit</button>
        <input style="display: none;" #mibFileSelector type="file" class="file-upload"
                        (change)="fileSelected($event)">
    </form>

</div>